import CodeMirror from 'codemirror'
import Parser from './../Core/Parser/Parser'

(function (CodeMirror) {
    function helper (word, line, column, code) {
        let hintsFound = []

        function hintCb (hintList) {
            for (let hint of hintList) {
                let addHint = true
                for (let found of hintsFound) {
                    if (found.text === hint.text) {
                        addHint = false
                        break
                    }
                }
                if (addHint) {
                    hintsFound.push(hint)
                }
            }
        }

        let parser = new Parser({
            config: window.LangConfig,
            hintCb: hintCb
        })
        try {
            parser.hint(word, line, column, code)
        } catch (e) {
            console.log(e)
        }
        return hintsFound
    }
    CodeMirror.registerHelper('hint', 'psflex', function (cm, option) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                let cursor = cm.getCursor()
                let line = cm.getLine(cursor.line)
                let start = cursor.ch
                let end = cursor.ch
                let found = []
                let word
                while (start && /\w/.test(line.charAt(start - 1))) {
                    --start
                }
                while (end < line.length && /\w/.test(line.charAt(end))) {
                    ++end
                }
                word = line.slice(start, end).toLowerCase()
                if (word.length > 0) {
                    found = helper(word, cursor.line, start, cm.getValue())
                }
                if (found.length > 0) {
                    let data = {
                        list: found,
                        from: CodeMirror.Pos(cursor.line, start),
                        to: CodeMirror.Pos(cursor.line, end)
                    }
                    return resolve(data)
                }
                return resolve(null)
            }, 100)
        })
    })
})(CodeMirror)



// WEBPACK FOOTER //
// ./src/Codemirror/hint.js